export var EMPTY_PROPS = {};
export var EMPTY_ARRAY = [];
export var EMPTY_FUNCTION = function EMPTY_FUNCTION() {
  return {};
};
export var FORMAT_FUNCTION = function FORMAT_FUNCTION(value) {
  return value;
};
export var DATE_PROP = new Date();